import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledParallexParagraphs } from "./parallex-paragraphs.scss";
const ParallexParagraphs = (props)=>{
    const { paragraphs } = props;
    return /*#__PURE__*/ _jsx(StyledParallexParagraphs, {
        className: "parallex-paragraphs",
        children: paragraphs.map((paragraph, index)=>/*#__PURE__*/ _jsxs("div", {
                className: "paragraph",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "headline",
                        children: /*#__PURE__*/ _jsx(FullParagraph, {
                            title: paragraph.title,
                            body: paragraph.description,
                            topic: {
                                text: ""
                            },
                            buttonConfig: paragraph.buttonConfig
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "social-proof",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                className: "avatar",
                                src: paragraph.avatarSrc,
                                alt: paragraph.avatarAlt
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "testimonial",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "“"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "main",
                                                children: [
                                                    paragraph.testimonial,
                                                    "”"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "person",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text",
                                                        children: paragraph.name
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "divider",
                                                        children: "|"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text",
                                                        children: paragraph.jobTitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "company",
                                                children: paragraph.companyName
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, `paragraph_${index}`))
    });
};
export default ParallexParagraphs;
